import React from "react";
const MealComponent = ({ oData }) => {
  const sImagePath = require(`../Multimedia/Images/${oData.sPath}`);

  return (
    <div className="flex-column center meal-card">
      <div
        style={{
          backgroundImage: `url(${sImagePath})`,
        }}
        className="meal-img"
      ></div>

      <h2 className="meal-name">{oData.sName}</h2>
      <h3 className="meal-price banner-background">{oData.sPrice}</h3>
    </div>
  );
};

export default MealComponent;
